import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  declare readonly inputTarget: HTMLInputElement
  declare readonly urlValue: string

  inputTargetConnected() {
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.setAttribute("src", this.urlValue)
  }
}
